import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { ComumModule } from './../../../shared/comum.module';
import { translateLoaderNBS } from './../../../shared/translate-loader/translateLoader';
import { GrupoImportadorCadastroComponent } from './grupo-importador-cadastro/grupo-importador-cadastro.component';
import { GrupoImportadorFiltroComponent } from './grupo-importador-filtro/grupo-importador-filtro.component';
import { GrupoImportadorListaComponent } from './grupo-importador-lista/grupo-importador-lista.component';
import { GrupoImportadorService } from './grupo-importador-service/grupo.importador.service';
import { GrupoImportadorComponent } from './grupo-importador.component';


@NgModule({
  imports: [
    HttpModule,
    FormsModule,
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    TranslateModule.forRoot(translateLoaderNBS)
  ],
  exports: [
    GrupoImportadorComponent
  ],
  declarations: [
    GrupoImportadorComponent,
    GrupoImportadorListaComponent,
    GrupoImportadorCadastroComponent,
    GrupoImportadorFiltroComponent
  ],
  providers: [
    GrupoImportadorService
  ]
})
export class GrupoImportadorModule { }
